/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { RecordEntry } from '../model/recordEntry';
import { BaseApi } from './base.api';
import { buildCollectionParam } from '../../../alfrescoApiClient';
import { throwIfNotDefined } from '../../../assert';
export class RecordsApi extends BaseApi {
    completeRecord(recordId, opts) {
        throwIfNotDefined(recordId, 'recordId');
        const pathParams = {
            recordId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.post({
            path: '/records/{recordId}/complete',
            pathParams,
            queryParams,
            returnType: RecordEntry
        });
    }
    deleteRecord(recordId) {
        throwIfNotDefined(recordId, 'recordId');
        const pathParams = {
            recordId
        };
        return this.delete({
            path: '/records/{recordId}',
            pathParams
        });
    }
    fileRecord(recordId, nodeBodyFile, opts) {
        throwIfNotDefined(recordId, 'recordId');
        throwIfNotDefined(nodeBodyFile, 'nodeBodyFile');
        const pathParams = {
            recordId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.post({
            path: '/records/{recordId}/file',
            pathParams,
            queryParams,
            bodyParam: nodeBodyFile,
            returnType: RecordEntry
        });
    }
    getRecord(recordId, opts) {
        throwIfNotDefined(recordId, 'recordId');
        const pathParams = {
            recordId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/records/{recordId}',
            pathParams,
            queryParams,
            returnType: RecordEntry
        });
    }
    getRecordContent(recordId, opts) {
        throwIfNotDefined(recordId, 'recordId');
        const pathParams = {
            recordId
        };
        const queryParams = {
            attachment: opts === null || opts === void 0 ? void 0 : opts.attachment
        };
        const headerParams = {
            'If-Modified-Since': opts === null || opts === void 0 ? void 0 : opts.ifModifiedSince
        };
        return this.get({
            path: '/records/{recordId}/content',
            pathParams,
            queryParams,
            headerParams
        });
    }
    updateRecord(recordId, recordBodyUpdate, opts) {
        throwIfNotDefined(recordId, 'recordId');
        throwIfNotDefined(recordBodyUpdate, 'recordBodyUpdate');
        const pathParams = {
            recordId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.put({
            path: '/records/{recordId}',
            pathParams,
            queryParams,
            bodyParam: recordBodyUpdate,
            returnType: RecordEntry
        });
    }
}
